import React, { useState } from "react";

const UserProfile = () => {
  const userHoldings = {
    '74fa9d1fe62900729c057e37f4241c2217ea678501c60334808391161a01507b': [
      { coin: "bitcoin", amount: 0.2 },
      { coin: "ethereum", amount: 3.25 },
      { coin: "solana", amount: 25 },
      { coin: "chainlink", amount: 52 },
      { coin: "uniswap", amount: 75 },
      { coin: "near", amount: 250 },
      { coin: "tether", amount: 1200 },
    ],
    '3867deec0cc9d459e47970652ecf123f4671b667352c8fb992a00990402ec074': [
      { coin: "USDT", amount: 1000 },
    ],
    user3: [
      { coin: "litecoin", amount: 10 },
      { coin: "ripple", amount: 2500 },
      { coin: "chainlink", amount: 50 },
    ],
  };

  const loggedInUser = localStorage.getItem("username") || "default"; // Retrieve username or use "default"
  const [holdings, setHoldings] = useState(
    userHoldings[loggedInUser] || [
      { coin: "bitcoin", amount: 0 },
      { coin: "ethereum", amount: 0 },
    ]
  );

  return (
    <div className="user-profile-container">
      <h2>{loggedInUser}'s Profile</h2>
      <div className="profile-table-wrapper">
        <table className="profile-table">
          <thead>
            <tr>
              <th>Coin</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {holdings.map((h) => (
              <tr key={h.coin}>
                <td>{h.coin.charAt(0).toUpperCase() + h.coin.slice(1)}</td>
                <td>{h.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserProfile;
